/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useLayout} from '../core'

const Footer: FC = () => {
  const {classes} = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'> 
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      > 
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <a href='eywatech.com.tr' className='text-gray-800 text-hover-primary' target="_blank">
            Eywa Bilgi Teknolojileri
          </a>
        </div> 
 
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='www.eywatech.com.tr/about' className='menu-link ps-0 pe-2' target="_blank">
              About
            </a>
          </li>
          <li className='menu-item'>
            <a href='www.eywatech.com.tr/contact' className='menu-link pe-0 pe-2' target="_blank">
              Contact
            </a>
          </li>
          <li className='menu-item'>
            <a href='www.eywatech.com.tr/contact' className='menu-link pe-0' target="_blank">
              Purchase
            </a>
          </li>
        </ul> 
      </div> 
    </div>
  )
}

export {Footer}
